import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CostDetailsComponent } from './cost-details.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

@NgModule({
  declarations: [CostDetailsComponent],
  imports: [
    CommonModule,
    FormsModule, ReactiveFormsModule,
  ],
  exports: [CostDetailsComponent],
  entryComponents: [CostDetailsComponent],
})
export class CostDetailsModule { }
